import React from "react";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import { Translation } from "./Translation";

export const ConfirmBox = ({
                               open,
                               onConfirm,
                               onCancel,
                               confirmDisabled,
                               title,
                               children
                           }) => {

    return (<Modal
        title={title}
        open={open}
        onClose={onCancel}
        describedById="modal-description" >
        <div id="modal-description">
            {children}
        </div>
        <ModalFooter>
            <Row alignmentHorizontal="right" widths="fit">
                <Button type="secondary" size="small" onClick={onCancel}>
                    <Translation stringId="modal_cancel_button" />
                </Button>
                <Button type="primary" size="small" onClick={onConfirm} disabled={confirmDisabled}>
                    <Translation stringId="modal_confirm_button" />
                </Button>
            </Row>
        </ModalFooter>
    </Modal>);
}


// WEBPACK FOOTER //
// ./src/components/scrub/ConfirmBox.js